import React, { useEffect, useMemo, useRef, useState } from "react";

import Select from "../../../Components/Select";
import Input from "../../../Components/Input";
import DateInput from "../../../Components/DateInput";

import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import ModelContainer from "../../../Components/ModelContainer";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";

import TimePicker from "react-times";
import "react-times/css/material/default.css";

import DynamicModal from "../../../Components/DynamicModal";
import { convertTo24HoursFormat } from "../../../../helpers";
import { el } from "date-fns/locale";
import DynamicTable from "../../../Components/DynamicTable";

const AddEmployee = ({ formOpen, setFormOpen, formType, setFormType }) => {
  const counter = useRef(0);
  counter.current++;
  console.log(counter.current, "reRenders");
  const dispatch = useDispatch();
  const editFormDefaultValues = useSelector(
    (state) => state?.settingReducer?.labourEmployeeEditData
  );

  const [dob, setDob] = useState(null);
  const [jobStartDate, setJobStartDate] = useState(null);
  const [jobEndDate, setJobEndDate] = useState(null);
  const [jobConfirmationDate, setJobConfirmationDate] = useState(null);
  const [workPermitEffectiveData, setWorkPermitEffectiveData] = useState(null);
  const [workPermitExpiryData, setWorkPermitExpiryData] = useState(null);
  const weekDays = [
    {
      day: "Monday",
      from: "monday_from",
      to: "monday_to",
      dayKey: "monday",
      selected:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["monday"],
      startTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["monday_from"],
      endTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["monday_to"],
    },
    {
      day: "Tuesday",
      from: "tuesday_from",
      to: "tuesday_to",
      dayKey: "tuesday",
      selected:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["tuesday"],
      startTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["tuesday_from"],
      endTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["tuesday_to"],
    },
    {
      day: "Wednesday",
      from: "wednesday_from",
      to: "wednesday_to",
      dayKey: "wednesday",

      selected:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["wednesday"],
      startTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["wednesday_from"],
      endTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["wednesday_to"],
    },
    {
      day: "Thurdsay",
      from: "thursday_from",
      to: "thursday_to",
      dayKey: "thursday",
      selected:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["thursday"],
      startTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["thursday_from"],
      endTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["thursday_to"],
    },
    {
      day: "Friday",
      from: "friday_from",
      to: "friday_to",
      dayKey: "friday",
      selected:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["friday"],
      startTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["friday_from"],
      endTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["friday_to"],
    },
    {
      day: "Saturday",
      from: "saturday_from",
      to: "saturday_to",
      dayKey: "saturday",
      selected:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["saturday"],
      startTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["saturday_from"],
      endTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["saturday_to"],
    },
    {
      day: "Sunday",
      from: "sunday_from",
      to: "sunday_to",
      dayKey: "sunday",
      selected:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["sunday"],
      startTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["sunday_from"],
      endTime:
        formType === "edit" &&
        editFormDefaultValues &&
        editFormDefaultValues["sunday_to"],
    },
  ];

  const userMerchantID = useSelector(
    (state) => state?.authReducer?.user_details?.user?.merchant_id
  );
  console.log(userMerchantID, "userMerchantID");
  const labourFormData = useSelector(
    (state) => state?.settingReducer?.labour_add_form_options
  );
  const labourEmployeeBankingInfo = useSelector(
    (state) => state?.settingReducer?.labourEmployeeBankingInfo
  );
  const labourEmployeeDocumentInfo = useSelector(
    (state) => state?.settingReducer?.labourEmployeeDocumentInfo
  );
  const labourEmployeeTaxDocumentInfo = useSelector(
    (state) => state?.settingReducer?.labourEmployeeTaxDocumentInfo
  );
  const labourEmployeeDependentsInfo = useSelector(
    (state) => state?.settingReducer?.labourEmployeeDependentsInfo
  );
  useEffect(() => {
    if (formType === "edit") {
      empolyeeFormReset(editFormDefaultValues);
    }
  }, [formType]);

  // DEPENDENTS MODAL START
  const addDependentsModalState = useSelector(
    (state) => state?.settingReducer?.labour_employee_dependents_modal_state
  );
  const setAddDependentsModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "labour_employee_dependents_modal_state",
        modalState: state,
      })
    );

  const [addDependentsModalInfo, setAddDependentsModalInfo] = useState({
    title: "Add Dependents Info",
    modalOpenState: addDependentsModalState,
    setModalOpenState: setAddDependentsModalState,
    postAddAction: actions.postEmployeeDependentsInfo,
    addDependentsModalInfo: addDependentsModalInfo,
    modalType: "add",
    modalElements: [
      {
        label: "Name ",
        elementType: "input",
        modalKey: "name",
        isRequired: "true",
      },
      {
        label: "Relationship",
        elementType: "input",
        modalKey: "relationship",
        isRequired: "true",
      },
      {
        label: "DOB",
        elementType: "date",
        modalKey: "dob",
        isRequired: "true",
        localStateValue: null,
      },
      {
        label: "ID Number",
        elementType: "input",
        modalKey: "id_number",
        isRequired: "true",
      },
    ],
    editModalState: null,
    postExtraKeys: null,
    editPostAction: actions.postEmployeeDependentsInfo,
  });
  useEffect(() => {
    setAddDependentsModalInfo({
      ...addDependentsModalInfo,
      modalOpenState: addDependentsModalState,
      modalType:
        addDependentsModalState === false
          ? "add"
          : addDependentsModalInfo.modalType,
    });
  }, [addDependentsModalState]);

  function updateEditDependentsModalState(key) {
    const editDetails = labourEmployeeDependentsInfo.find(
      (el) => el.key === key
    );
    setAddDependentsModalInfo({
      ...addDependentsModalInfo,
      editModalState: editDetails,
      modalType: "edit",
      postExtraKeys: {
        ...addDependentsModalInfo?.postExtraKeys,
        key: editDetails?.key,
        id: editDetails?.id,
      },
    });
    console.log(addDependentsModalInfo, "iiiiiiii");
  }

  // DEPENDENTS MODAL END

  // DOCUMENT MODAL START
  const addDocumentModalState = useSelector(
    (state) => state?.settingReducer?.labour_employee_add_document_modal_state
  );
  const setAddDocumentModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "labour_employee_add_document_modal_state",
        modalState: state,
      })
    );
  const [addDocumentModalInfo, setAddDocumentModalInfo] = useState({
    title: "Add Document Info",
    modalOpenState: addDocumentModalState,
    setModalOpenState: setAddDocumentModalState,
    containsFile: true,
    postAddAction: actions.postEmployeeDocumentInfo,
    modalType: "add",
    modalElements: [
      {
        label: "Document Name ",
        elementType: "input",
        modalKey: "document_name",
        isRequired: "true",
      },
      {
        label: "Document",
        elementType: "input",
        modalKey: "document",
        inputType: "file",
        isRequired: "true",
        dataType: "mixed",
      },
    ],
    editModalState: null,
    postExtraKeys: null,
    editPostAction: actions.postEmployeeDocumentInfo,
  });
  useEffect(() => {
    setAddDocumentModalInfo({
      ...addDocumentModalInfo,
      modalOpenState: addDocumentModalState,
      modalType:
        addDocumentModalState === false
          ? "add"
          : addDocumentModalInfo.modalType,
    });
  }, [addDocumentModalState]);

  function updateEditDocumentModalState(key) {
    const editDetails = labourEmployeeDocumentInfo.find((el) => el.key === key);
    setAddDocumentModalInfo({
      ...addDocumentModalInfo,
      editModalState: editDetails,
      modalType: "edit",
      postExtraKeys: {
        ...addDocumentModalInfo?.postExtraKeys,
        key: editDetails?.key,
        id: editDetails?.id,
      },
    });
    console.log(addDocumentModalInfo, "iiiiiiii");
  }

  // DOCUMENT MODAL END

  // TAX DOCUMENT MODAL START
  const addTaxDocumentModalState = useSelector(
    (state) =>
      state?.settingReducer?.labour_employee_add_tax_document_modal_state
  );
  const setAddTaxDocumentModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "labour_employee_add_tax_document_modal_state",
        modalState: state,
      })
    );
  const [addTaxDocumentModalInfo, setAddTaxDocumentModalInfo] = useState({
    title: "Add Tax Document Info",
    modalOpenState: addTaxDocumentModalState,
    setModalOpenState: setAddTaxDocumentModalState,
    containsFile: true,
    postAddAction: actions.postEmployeeTaxDocumentInfo,
    modalType: "add",
    modalElements: [
      {
        label: "Document Name ",
        elementType: "input",
        modalKey: "document_name",
        isRequired: "true",
      },
      {
        label: "Document",
        elementType: "input",
        modalKey: "document",
        inputType: "file",
        isRequired: "true",
        dataType: "mixed",
      },
    ],
    editModalState: null,
    postExtraKeys: null,
    editPostAction: actions.postEmployeeTaxDocumentInfo,
  });
  useEffect(() => {
    setAddTaxDocumentModalInfo({
      ...addTaxDocumentModalInfo,
      modalOpenState: addTaxDocumentModalState,
      modalType:
        addTaxDocumentModalState === false
          ? "add"
          : addTaxDocumentModalInfo.modalType,
    });
  }, [addTaxDocumentModalState]);

  function updateEditTaxDocumentModalState(key) {
    const editDetails = labourEmployeeTaxDocumentInfo.find(
      (el) => el.key === key
    );
    setAddTaxDocumentModalInfo({
      ...addTaxDocumentModalInfo,
      editModalState: editDetails,
      modalType: "edit",
      postExtraKeys: {
        ...addTaxDocumentModalInfo?.postExtraKeys,
        key: editDetails?.key,
        id: editDetails?.id,
      },
    });
    console.log(addTaxDocumentModalInfo, "iiiiiiii");
  }

  // TAX DOCUMENT MODAL END

  // BANKING MODAL START
  const addBankingModalState = useSelector(
    (state) => state?.settingReducer?.labour_employee_add_banking_modal_state
  );
  const setAddBankingModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "labour_employee_add_banking_modal_state",
        modalState: state,
      })
    );

  const [addBankingModalInfo, setAddBankingModalInfo] = useState({
    title: "Add Banking Info",
    modalOpenState: addBankingModalState,
    setModalOpenState: setAddBankingModalState,
    modalType: "add",
    postAddAction: actions.postEmployeeBankingInfo,
    modalElements: [
      {
        label: "Bank Name ",
        elementType: "select",
        modalKey: "bank_name",
        optionsArray: labourFormData?.banks,
        isRequired: true,
      },
      {
        label: "Account #",
        elementType: "input",
        modalKey: "account_num",
        isRequired: true,
      },
      {
        label: "Routing",
        elementType: "input",
        modalKey: "routing_num",
        notRequired: true,
      },
      {
        label: "Primary?",
        elementType: "select",
        modalKey: "primary",
        optionsArray: [
          { value: 0, label: "No" },
          { value: 1, label: "Yes" },
        ],
        isRequired: true,
      },
    ],
    editModalState: null,
    postExtraKeys: null,
    editPostAction: actions.postEmployeeBankingInfo,
  });
  useEffect(() => {
    setAddBankingModalInfo({
      ...addBankingModalInfo,
      modalOpenState: addBankingModalState,
      modalType:
        addBankingModalState === false ? "add" : addBankingModalInfo.modalType,
    });
  }, [addBankingModalState]);

  function updateEditBankingModalState(key) {
    const editDetails = labourEmployeeBankingInfo.find((el) => el.key === key);
    setAddBankingModalInfo({
      ...addBankingModalInfo,
      editModalState: editDetails,
      modalType: "edit",
      postExtraKeys: {
        ...addBankingModalInfo?.postExtraKeys,
        key: editDetails?.key,
        id: editDetails?.id,
      },
    });
    console.log(addBankingModalInfo, "iiiiiiii");
  }
  // BANKING MODAL END

  const empolyeeFormSchema = yup.object({
    merchant_id: yup.string().required(),
    employment_status_id: yup.string().required(),
    employee_name: yup.string().required(),
    last_name: yup.string().required(),
    nickname: yup.string().required(),
    identification_pin: yup.string().required(),
    dob: yup.string().required(),
    address_line_1: yup.string().required(),
    city_id: yup.string().required(),
    state_id: yup.string().required(),
    country_id: yup.string().required(),
    zip_code: yup.string().required(),
    contact_number_1: yup.string().required(),
    email: yup.string().required(),
    contact_preference_id: yup.string().required(),
    employee_function_id: yup.string().required(),
    role_title: yup.string().required(),
    employee_category_id: yup.string().required(),
    start_date: yup.string().required(),
    work_permit_type: yup.string().required(),
    emergency_contact_name: yup.string().required(),
    relationship: yup.string().required(),
    emergency_contact_number: yup.string().required(),
    filing_status_id: yup.string().required(),
    annual_salary: yup.string().required(),
    // payroll_frequency_id: yup.string().required(),
    allowance_id: yup.string().required(),
    pa_time_period_id: yup.string().required(),
    account_approving_manager: yup.string().required(),
    account_approving_manager: yup.string().required(),
    education_level: yup.string().required(),
    //
  });
  const addFormDefaultValues = {
    monday: 0,
    monday_from: "10:00:00",
    monday_to: "16:00:00",
    tuesday: 0,
    tuesday_from: "10:00:00",
    tuesday_to: "16:00:00",
    wednesday: 0,
    wednesday_from: "10:00:00",
    wednesday_to: "16:00:00",
    thursday: 0,
    thursday_from: "10:00:00",
    thursday_to: "16:00:00",
    friday: 0,
    friday_from: "10:00:00",
    friday_to: "16:00:00",
    saturday: 0,
    saturday_from: "10:00:00",
    saturday_to: "16:00:00",
    sunday: 0,
    sunday_from: "10:00:00",
    sunday_to: "16:00:00",
  };
  const {
    register: empolyeeFormRegister,
    formState: { errors: empolyeeFormError },
    handleSubmit: empolyeeFormSubmit,
    reset: empolyeeFormReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(empolyeeFormSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:
      formType === "add" ? addFormDefaultValues : editFormDefaultValues,
  });

  function submitData(data) {
    console.log(data, "ooooiiii");
    if (formType === "add") {
      dispatch(
        actions.postLabourAddEmployeeFormData({
          ...data,
          payroll_frequency_id: "2",
        })
      );
    } else {
      dispatch(
        actions.postEditLabourEmployeeData({
          ...data,
          payroll_frequency_id: "2",
        })
      );
      console.log(
        {
          ...data,
          payroll_frequency_id: "2",
        },
        "edittttt"
      );
    }
    // dispatch(
    //   actions.postLabourAddEmployeeFormData({
    //     merchant_id: "26",
    //     employment_status_id: "1",
    //     employee_name: "das",
    //     last_name: "samad",
    //     nickname: "dsa",
    //     race: "",
    //     religion: "",
    //     identification_pin: "432",
    //     dob: "2022-6-6",
    //     address_line_1: "dsa",
    //     address_line_2: "",
    //     city_id: "dsa",
    //     state_id: "ads",
    //     country_id: "1",
    //     zip_code: "321321",
    //     contact_number_1: "432432324",
    //     contact_number_2: "",
    //     email: "test1@mailinator.com",
    //     contact_preference_id: "2",
    //     employee_function_id: "1",
    //     role_title: "234",
    //     employee_category_id: "1",
    //     work_week_type: "",
    //     rosterable: "",
    //     start_date: "2022-7-5",
    //     account_approving_manager: "no",
    //     approving_manager: "",
    //     confirmation_status: "",
    //     confirmed_by: "",
    //     work_permit_type: "4",
    //     education_level: "3",
    //     institution_name: "",
    //     emergency_contact_name: "e",
    //     relationship: "fwe",
    //     emergency_contact_number: "fw",
    //     emergency_contact_email: "wf",
    //     filing_status_id: "1",
    //     allowance_id: "1",
    //     annual_salary: "3223",
    //     payroll_frequency_id: "2",
    //     pa_time_period_id: "3",
    //     monday: 1,
    //     monday_from: "16:10:00",
    //     monday_to: "16:25:00",
    //     tuesday: 0,
    //     wednesday: 0,
    //     thursday: 0,
    //     friday: 0,
    //     saturday: 0,
    //     sunday: 0,
    //   })
    // );
  }

  return (
    <>
      <DynamicModal
        modalInfo={addDependentsModalInfo}
        setModalInfo={setAddDependentsModalInfo}
      />

      <DynamicModal modalInfo={addDocumentModalInfo} />

      <DynamicModal modalInfo={addBankingModalInfo} />

      <DynamicModal modalInfo={addTaxDocumentModalInfo} />

      <form onSubmit={empolyeeFormSubmit(submitData)}>
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row employeeSettingSec d-flex">
              <div className="col-md-8">
                <div className="shadowclass d-flex h-100 flex-wrap align-content-start">
                  <h4 className="event-alert w-100">
                    Employee Details
                    <span className="green_tag active-tag"> Active </span>
                  </h4>
                  <div className="d-flex calc-height flex-wrap">
                    <div className="settings-left-content fixed-pos d-none d-sm-block">
                      <ul className="settingMenus">
                        <li id="AccDetail_li" className="active">
                          <a href="#_" id="AccDetail_dayTime_a">
                            Personal <br />
                            Details
                          </a>
                        </li>
                        <li id="Address_li" className="">
                          <a href="#_" id="Address_dayTime_a">
                            Address
                          </a>
                        </li>
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            Contact Details
                          </a>
                        </li>
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            Job Info
                          </a>
                        </li>
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            Work Permit &amp; <br /> Education Info
                          </a>
                        </li>
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            Children &amp; <br />
                            Dependents
                          </a>
                        </li>
                        <li id="FinSettings_li" className="">
                          <a href="#_" id="FinSettings_dayTime_a">
                            Emergency <br />
                            Contact Info
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="settings-right-content scrolling">
                      <div className="date-sec-scroll">
                        <div
                          id="AccDetail_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="AccDetail"
                        >
                          <div className="form-secs">
                            <h4> Personal Details</h4>

                            <ul class="ingredient-info edit-shift">
                              <Select
                                label={"Account"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="merchant_id"
                                optionsArray={labourFormData?.accounts}
                                onChange={(e) => {}}
                              />

                              <Select
                                label={"Status"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="employment_status_id"
                                optionsArray={
                                  labourFormData?.employmentStatuses
                                }
                                onChange={(e) => {}}
                              />

                              <Input
                                label={"First Name"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="employee_name"
                              />

                              <Input
                                label={"Last Name"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="last_name"
                              />

                              <Input
                                label={"Nickname"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="nickname"
                              />

                              <Select
                                label={"Race"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="race"
                                optionsArray={labourFormData?.races}
                                onChange={(e) => {}}
                                notRequired
                              />

                              <Select
                                label={"Religion"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="religion"
                                optionsArray={labourFormData?.religions}
                                onChange={(e) => {}}
                                notRequired
                              />

                              <Input
                                label={"ID # / Passport #"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="identification_pin"
                              />

                              <DateInput
                                label="Date of Birth"
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="dob"
                                dateVal={dob}
                                setDateVal={setDob}
                                setFormField={setValue}
                              />
                            </ul>
                          </div>
                        </div>

                        <div
                          id="Address_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="Address"
                        >
                          <div className="form-secs">
                            <h4> Address </h4>
                            <ul class="ingredient-info edit-shift d-flex">
                              <Input
                                label={"Address Line #1"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="address_line_1"
                              />
                              <Input
                                label={"Address Line #2"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="address_line_2"
                                notRequired
                              />

                              <Input
                                label={"City"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="city_id"
                              />

                              <Input
                                label={"State"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="state_id"
                              />

                              <Select
                                label={"Country"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="country_id"
                                optionsArray={labourFormData?.countries}
                                onChange={(e) => {}}
                              />

                              <Input
                                label={"Zip Code"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="zip_code"
                              />
                            </ul>
                          </div>
                        </div>

                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4> Contact Details</h4>
                            <ul class="ingredient-info edit-shift">
                              <Input
                                label={"Contact Number #1"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="contact_number_1"
                              />
                              <Input
                                label={"Contact Number #2"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="contact_number_2"
                                notRequired
                              />
                              <Input
                                label={"Email"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="email"
                              />
                              <Select
                                label={"Contact Preference"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="contact_preference_id"
                                optionsArray={
                                  labourFormData?.contactPreferences
                                }
                                onChange={(e) => {}}
                              />
                            </ul>
                          </div>
                        </div>

                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4> Job Info</h4>
                            <ul class="ingredient-info edit-shift d-flex">
                              <Select
                                label={"Function"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="employee_function_id"
                                optionsArray={labourFormData?.employeeFunctions}
                                onChange={(e) => {}}
                              />
                              <Input
                                label={"Role Title"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="role_title"
                              />
                              <Select
                                label={"Category"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="employee_category_id"
                                optionsArray={labourFormData?.emp_category}
                                onChange={(e) => {}}
                              />
                              <Select
                                label={"Work Week Type"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="work_week_type"
                                optionsArray={labourFormData?.work_week_type}
                                onChange={(e) => {}}
                                notRequired
                              />
                              <Select
                                label={"Restorable"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="rosterable"
                                optionsArray={labourFormData?.yes_no}
                                onChange={(e) => {}}
                                notRequired
                              />
                              <DateInput
                                label="Start Date"
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="start_date"
                                dateVal={jobStartDate}
                                setDateVal={setJobStartDate}
                                setFormField={setValue}
                              />

                              <DateInput
                                label="End Date"
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="end_date"
                                dateVal={jobEndDate}
                                setDateVal={setJobEndDate}
                                setFormField={setValue}
                                notRequired
                              />
                              <Select
                                label={"Account Approving Manager"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="account_approving_manager"
                                optionsArray={labourFormData?.yes_no}
                                onChange={(e) => {}}
                              />

                              <Select
                                label={"Approving Manager"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="approving_manager"
                                optionsArray={labourFormData?.approving_manager}
                                onChange={(e) => {}}
                                notRequired
                              />

                              <DateInput
                                label="Confirmation Date"
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="confirmation_date"
                                dateVal={jobConfirmationDate}
                                setDateVal={setJobConfirmationDate}
                                setFormField={setValue}
                                notRequired
                              />

                              <Select
                                label={"Confirmation Status"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="confirmation_status"
                                optionsArray={
                                  labourFormData?.confirmation_status
                                }
                                onChange={(e) => {}}
                                notRequired
                              />

                              <Input
                                label={"Confirmed By"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="confirmed_by"
                                notRequired
                              />
                            </ul>
                          </div>
                        </div>

                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4> Work Permit</h4>
                            <ul class="ingredient-info edit-shift d-flex">
                              <Select
                                label={"Work Permit Type"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="work_permit_type"
                                optionsArray={labourFormData?.workPermit}
                                onChange={(e) => {}}
                              />

                              <DateInput
                                label="Effective Date"
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="permit_effective_date"
                                dateVal={workPermitEffectiveData}
                                setDateVal={setWorkPermitEffectiveData}
                                setFormField={setValue}
                                notRequired
                              />
                              <DateInput
                                label="Expiry Date"
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="permit_expiry_date"
                                dateVal={workPermitExpiryData}
                                setDateVal={setWorkPermitExpiryData}
                                setFormField={setValue}
                                notRequired
                              />
                              <Select
                                label={"Education Level"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="education_level"
                                optionsArray={labourFormData?.educationLevel}
                                onChange={(e) => {}}
                              />
                              <Input
                                label={"Highest Institution Name"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="institution_name"
                                notRequired
                              />
                            </ul>
                          </div>
                        </div>

                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4> Children &amp; Dependents</h4>
                            <ul class="ingredient-info edit-shift d-flex">
                              <li>
                                <table
                                  id="Dependents"
                                  class="checklist-table remove-space aviTable"
                                  cellspacing="0"
                                  cellpadding="0"
                                  width="100%"
                                >
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                      <th>Relationship</th>
                                      <th>DOB</th>
                                      <th>ID Number</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody id="ChildrenDependent">
                                    {labourEmployeeDependentsInfo?.map((el) => (
                                      <tr>
                                        <td>{el?.name}</td>
                                        <td>{el?.relationship}</td>
                                        <td>{el?.dob}</td>
                                        <td>{el?.id_number}</td>
                                        <td>
                                          <p
                                            onClick={() => {
                                              setAddDependentsModalState(true);
                                              updateEditDependentsModalState(
                                                el.key
                                              );
                                            }}
                                            className="circle_icon edit_tooltip"
                                          >
                                            <i class="iconSprites edit-icon"></i>{" "}
                                          </p>
                                          <p
                                            class="circle_icon red"
                                            onClick={() => {
                                              dispatch(
                                                actions.deleteEmployeeDependentsInfo(
                                                  {
                                                    key: el.key,
                                                  }
                                                )
                                              );
                                            }}
                                          >
                                            <i class="iconSprites delete-icon"></i>
                                          </p>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div class="my-3">
                                  <p
                                    onClick={() =>
                                      setAddDependentsModalState(true)
                                    }
                                    id="addDependents"
                                    class="btn green-btn-revert add-plus"
                                  >
                                    <i class="i-icon"> </i> Add Dependent{" "}
                                  </p>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div
                          id="FinSettings_dayTime_div"
                          className="row-fluid scroll-change full_div"
                          day_time="FinSettings"
                        >
                          <div className="form-secs">
                            <h4> Emergency Contact Info </h4>
                            <ul class="ingredient-info edit-shift d-flex">
                              <Input
                                label={"Contact Name"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="emergency_contact_name"
                              />
                              <Input
                                label={"Relationship"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="relationship"
                              />
                              <Input
                                label={"Contact Number"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="emergency_contact_number"
                              />
                              <Input
                                label={"Contact Email"}
                                formRegister={empolyeeFormRegister}
                                formError={empolyeeFormError}
                                formKey="emergency_contact_email"
                                notRequired
                              />
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 timeSetting operatingDaysMs pay-performance">
                <div className="shadowclass d-flex h-100 flex-wrap align-content-start">
                  <h4 className="event-alert w-100">
                    Pay, Benefits, &amp; Taxes
                  </h4>
                  <ul class="ingredient-info payPerform">
                    <Select
                      label={"Filing Status"}
                      formRegister={empolyeeFormRegister}
                      formError={empolyeeFormError}
                      formKey="filing_status_id"
                      optionsArray={labourFormData?.filingStatuses}
                      onChange={(e) => {}}
                    />

                    <Select
                      label={"Dependents"}
                      formRegister={empolyeeFormRegister}
                      formError={empolyeeFormError}
                      formKey="allowance_id"
                      optionsArray={labourFormData?.allowances?.map((el) => ({
                        value: el,
                        label: el,
                      }))}
                      onChange={(e) => {}}
                    />
                    <Input
                      label={"Annual Salary"}
                      formRegister={empolyeeFormRegister}
                      formError={empolyeeFormError}
                      formKey="annual_salary"
                    />
                    <Select
                      label={"Applicable Payroll"}
                      formRegister={empolyeeFormRegister}
                      formError={empolyeeFormError}
                      formKey="payroll_frequency_id"
                      optionsArray={labourFormData?.payroll_frequency}
                      onChange={(e) => {}}
                    />
                    <li>
                      <label> Applicable Weekly Overtime </label>
                      <div class="input-group">
                        <input
                          name="data[Employee][overtime_rule_weekly_name]"
                          id="overtime_rule_w"
                          placeholder="Select Weekly Rule"
                          type="text"
                          disabled="disabled"
                        />{" "}
                      </div>
                      <input
                        type="hidden"
                        name="data[Employee][overtime_weekly_rule_id]"
                        id="EmployeeOvertimeWeeklyRuleId"
                      />
                    </li>
                    <li>
                      <label>
                        {" "}
                        Applicable Weekly Overtime{" "}
                        <span class="hide-small">Rule</span>
                      </label>
                      <div class="input-group">
                        <input
                          name="data[Employee][overtime_rule_weekly_name]"
                          id="overtime_rule_w"
                          placeholder="Select Weekly Rule"
                          type="text"
                          disabled="disabled"
                        />{" "}
                      </div>
                      <input
                        type="hidden"
                        name="data[Employee][overtime_weekly_rule_id]"
                        id="EmployeeOvertimeWeeklyRuleId"
                      />
                    </li>
                    <li>
                      <label>
                        {" "}
                        Applicable Daily Overtime{" "}
                        <span class="hide-small">Rule</span>
                      </label>
                      <div class="input-group">
                        <input
                          name="data[Employee][overtime_rule_daily_name]"
                          id="overtime_rule"
                          placeholder="Select Daily Rule"
                          type="text"
                          disabled="disabled"
                        />{" "}
                      </div>
                      <input
                        type="hidden"
                        name="data[Employee][overtime_rule_id]"
                        id="EmployeeOvertimeRuleId"
                      />{" "}
                    </li>
                    <li>
                      <label>
                        {" "}
                        Applicable Public Holiday{" "}
                        <span class="hide-small">Rule</span>
                      </label>
                      <div class="input-group">
                        <input
                          name="data[Employee][public_holiday_rule_name]"
                          id="overtime_rule_public_holiday"
                          placeholder="Select Public Holiday Rule"
                          type="text"
                          disabled="disabled"
                        />{" "}
                      </div>
                      <input
                        type="hidden"
                        name="data[Employee][public_holiday_rule_id]"
                        id="EmployeePublicHolidayRuleId"
                      />{" "}
                    </li>
                    <li>
                      <label>
                        Applicable Allowance{" "}
                        <span class="hide-small">Rule</span>
                      </label>
                      <div class="input-group">
                        <input
                          name="data[Employee][meal_allowance_rule_name]"
                          id="meal_allowance_rule"
                          placeholder="Select Meal Allowance Rule"
                          type="text"
                          disabled="disabled"
                        />{" "}
                      </div>
                      <input
                        type="hidden"
                        name="data[Employee][meal_allowance_rule_id]"
                        id="EmployeeMealAllowanceRuleId"
                      />{" "}
                    </li>
                    <Select
                      label={"Time Period"}
                      formRegister={empolyeeFormRegister}
                      formError={empolyeeFormError}
                      formKey="pa_time_period_id"
                      optionsArray={labourFormData?.paTimePeriods}
                      onChange={(e) => {}}
                      notRequired
                    />
                    <li>
                      <label>Tax Documents</label>
                      <div class="table-responsive w-100">
                        <table
                          id="TableDable"
                          class="checklist-table remove-space aviTable"
                          cellspacing="0"
                          cellpadding="0"
                          width="100%"
                        >
                          <tbody>
                            {labourEmployeeTaxDocumentInfo?.map((el) => (
                              <tr>
                                <td>
                                  <a href={el?.document} target="blank">
                                    <i class="icon"> </i> {el?.document_name}{" "}
                                  </a>
                                </td>
                                <td>
                                  Uploaded{" "}
                                  {el?.modified?.slice(
                                    0,
                                    el?.modified.indexOf("T")
                                  )}
                                </td>
                                <td>
                                  <p
                                    onClick={() => {
                                      setAddTaxDocumentModalState(true);
                                      updateEditTaxDocumentModalState(el.key);
                                    }}
                                    className="circle_icon edit_tooltip"
                                  >
                                    <i class="iconSprites edit-icon"></i>{" "}
                                  </p>
                                  <p
                                    class="circle_icon red"
                                    onClick={() => {
                                      dispatch(
                                        actions.deleteEmployeeTaxDocumentInfo({
                                          key: el.key,
                                        })
                                      );
                                    }}
                                  >
                                    <i class="iconSprites delete-icon"></i>
                                  </p>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div class="my-3">
                          <p
                            onClick={() => setAddTaxDocumentModalState(true)}
                            id="addTaxDocument"
                            class="btn green-btn-revert add-plus"
                          >
                            <i class="i-icon"> </i> Add Document{" "}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row employeeSettingSec d-flex">
              <div className="col-md-8 d-flex">
                <div class="shadowclass">
                  <h4 class="event-alert">Leave / Medical Allowance</h4>
                  <div class="inner-space screen-scroll">
                    <table
                      width="100%"
                      cellspacing="0"
                      cellpadding="0"
                      class="checklist-table remove-space inventory_table"
                    >
                      <thead>
                        <tr>
                          <th>
                            <a href="#_" class="">
                              {" "}
                              Leave Type{" "}
                            </a>
                          </th>
                          <th> Leave Name </th>
                          <th> Alloted </th>
                          <th> Accrued </th>
                          <th> Used </th>
                          <th> Remaining </th>
                          <th> Pending </th>
                          <th> </th>
                          <th> Actions </th>
                        </tr>
                      </thead>
                      <tbody id="leaveTbody">
                        {formType === "edit" &&
                          editFormDefaultValues?.leaves?.map((el) => (
                            <tr>
                              <td>{el?.leave_type?.name}</td>
                              <td>{el?.leave_type?.name}</td>
                              <td>{el?.allotted?.toFixed(2)}</td>
                              <td>{el?.accrued?.toFixed(2)}</td>
                              <td>{el?.used?.toFixed(2)}</td>
                              <td>{el?.remaining?.toFixed(2)}</td>
                              <td>{el?.pending?.toFixed(2)}</td>
                              <td>{el?.expired?.toFixed(2)}</td>
                              <td>
                                {" "}
                                <p
                                  onClick={() => {}}
                                  className="circle_icon eye_icon"
                                >
                                  <i class="iconSprites eye-icon"></i>{" "}
                                </p>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="col-md-4 timeSetting d-flex operatingDaysMs">
                <div className="shadowclass">
                  <h4 className="event-alert">Operating Days &amp; Hours</h4>
                  <div className="table-responsive w-100 screen-scroll">
                    <table className="checklist-table remove-space aviTable">
                      <thead>
                        <tr>
                          <th width="15">&nbsp;</th>
                          <th class="col-2">Day</th>
                          <th class="col-5">From</th>
                          <th class="col-5">To</th>
                        </tr>
                      </thead>
                      <tbody>
                        {weekDays?.map((el) => (
                          <Weekday
                            formRegister={empolyeeFormRegister}
                            setFormField={setValue}
                            startFormKey={el.from}
                            endFormKey={el.to}
                            dayName={el.day}
                            dayKey={el.dayKey}
                            selected={el?.selected}
                            startTime={el?.startTime}
                            endTime={el?.endTime}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="row employeeSettingSec d-flex">
              <div className="col-md-8 d-flex">
                <DynamicTable
                  tableInfo={{
                    title: "Banking Info",
                    actions: true,
                    editable: true,
                    deleteable: true,
                    showLowerAddButton: true,
                    addButtonTitle: "Add Account",
                    headings: [
                      "Bank Name",
                      "Account #",
                      "Routing #",
                      "Primary Account",
                      "Actions",
                    ],
                    dataArray: labourEmployeeBankingInfo,
                    dataKeys: [
                      "bank_name",
                      "account_num",
                      "routing_num",
                      "primary",
                    ],
                    editKey: "key",
                    deleteKeyValuePairs: [{ key: "key", value: "key" }],
                    editOnClick: function (key) {
                      setAddBankingModalState(true);
                      updateEditBankingModalState(key);
                    },
                    addOnClick: function () {
                      setAddBankingModalState(true);
                    },
                    deleteOnClick: function (deleteKeyValuePairs) {
                      dispatch(
                        actions.deleteEmployeeBankingInfo(deleteKeyValuePairs)
                      );
                    },
                  }}
                />
                {/* <div class="shadowclass mt-0">
                  <h4 class="event-alert">Banking Info</h4>
                  <div class="table-responsive w-100">
                    <table
                      id="TableDable"
                      class="checklist-table remove-space"
                      cellspacing="0"
                      cellpadding="0"
                      width="100%"
                    >
                      <thead>
                        <tr>
                          <th>Bank Name</th>
                          <th>Account #</th>
                          <th>Routing #</th>
                          <th>Primary Account?</th>
                          <th>Actions?</th>
                        </tr>
                      </thead>
                      <tbody id="bankingIndex">
                        {labourEmployeeBankingInfo?.map((el) => (
                          <tr>
                            <td>{el?.bank_name}</td>
                            <td>{el?.account_num}</td>
                            <td>{el?.routing_num}</td>
                            <td>{el?.primary}</td>
                            <td>
                              <p
                                onClick={() => {
                                  setAddBankingModalState(true);
                                  updateEditBankingModalState(el.key);
                                }}
                                className="circle_icon edit_tooltip"
                              >
                                <i class="iconSprites edit-icon"></i>{" "}
                              </p>
                              <p
                                class="circle_icon red"
                                onClick={() => {
                                  dispatch(
                                    actions.deleteEmployeeBankingInfo({
                                      key: el.key,
                                    })
                                  );
                                }}
                              >
                                <i class="iconSprites delete-icon"></i>
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div class="my-3">
                      <p
                        onClick={() => {
                          setAddBankingModalState(true);
                        }}
                        id="addBanking"
                        class="btn green-btn-revert add-plus"
                      >
                        <i class="i-icon"> </i> Add Account{" "}
                      </p>
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="col-md-4 timeSetting d-flex">
                <div className="shadowclass mt-0">
                  <h4 class="event-alert">Documents</h4>
                  <div class="table-responsive w-100">
                    <table
                      id="TableDable"
                      class="checklist-table remove-space aviTable"
                      cellspacing="0"
                      cellpadding="0"
                      width="100%"
                    >
                      <tbody id="documentIndex" className="d-table w-100">
                        {labourEmployeeDocumentInfo?.map((el) => (
                          <tr>
                            <td>
                              <a href={el?.document} target="blank" class="attachments">
                                <i class="icon"> </i> {el?.document_name}{" "}
                              </a>
                            </td>
                            <td>
                              Uploaded{" "}
                              {el?.modified?.slice(
                                0,
                                el?.modified.indexOf("T")
                              )}
                            </td>
                            <td class="action-td">
                              <div className="d-flex pt-0 justify-content-end">
                                <div
                                  onClick={() => {
                                    setAddDocumentModalState(true);
                                    updateEditDocumentModalState(el.key);
                                  }}
                                  className="circle_icon m-0"
                                >
                                  <i class="iconSprites edit-icon"></i>{" "}
                                </div>
                                <div
                                  class="circle_icon m-0 red"
                                  onClick={() => {
                                    dispatch(
                                      actions.deleteEmployeeDocumentInfo({
                                        key: el.key,
                                      })
                                    );
                                  }}
                                >
                                  <i class="iconSprites delete-icon"></i>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div class="my-3">
                      <p
                        onClick={() => setAddDocumentModalState(true)}
                        id="addDocument"
                        class="btn green-btn-revert add-plus"
                      >
                        <i class="i-icon"> </i> Add Document{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix"> &nbsp;</div>
        <div class="row mx-0">
          <div class="container px-0 d-flex col-12">
            <div class="btns col-4 d-flex justify-content-end py-4 col-12">
              <button type="Submit">Save </button>
              <button
                onClick={() => {
                  setFormOpen(false);
                  setFormType(null);
                }}
                id="cancel"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

const Weekday = ({
  formRegister,
  startFormKey,
  endFormKey,
  setFormField,
  dayName,
  dayKey,
  selected,
  startTime,
  endTime,
}) => {
  const [startTimeVal, setStartTimeVal] = useState(startTime || null);
  const [endTimeVal, setEndTimeVal] = useState(endTime || null);
  const [dayChecked, setDayChecked] = useState(selected || 0);
  return (
    <tr>
      <td width="15">
        <div className="checkbox avaiCheck">
          <input
            type="checkbox"
            {...formRegister(dayKey)}
            onChange={(e) => {
              setDayChecked(dayChecked === 0 ? 1 : 0);
              setFormField(dayKey, dayChecked === 0 ? 1 : 0);
              console.log("eeeeee", dayChecked);
            }}
            checked={dayChecked}
            className="avail_checkbox"
            id={dayName}
          />
          <label for={dayName}></label>
        </div>
      </td>
      <td className="">{dayName}</td>
      <td className="set-mob">
        <div className="timePicker">
          <TimePicker
            timeMode={"12"}
            {...formRegister(startFormKey)}
            time={startTimeVal}
            onTimeChange={(options) => {
              const hours = options.hour;
              const minute = options.minute;
              const meridiem = options.meridiem;
              console.log(
                convertTo24HoursFormat(
                  `${hours}:${minute} ${meridiem.toUpperCase()}`
                ),
                "popopopopo"
              );
              setFormField(
                startFormKey,
                convertTo24HoursFormat(
                  `${hours}:${minute} ${meridiem.toUpperCase()}`
                )
              );
              setStartTimeVal(
                convertTo24HoursFormat(
                  `${hours}:${minute} ${meridiem.toUpperCase()}`
                )
              );
            }}
          />
        </div>
      </td>
      <td>
        <div className="input-append bootstrap-timepicker">
          <TimePicker
            timeMode={"12"}
            {...formRegister(endFormKey)}
            time={endTimeVal}
            onTimeChange={(options) => {
              const hours = options.hour;
              const minute = options.minute;
              const meridiem = options.meridiem;
              console.log(options, "bbbb");

              setFormField(
                endFormKey,
                convertTo24HoursFormat(
                  `${hours}:${minute} ${meridiem.toUpperCase()}`
                )
              );
              setEndTimeVal(
                convertTo24HoursFormat(
                  `${hours}:${minute} ${meridiem.toUpperCase()}`
                )
              );
            }}
          />
          {/* <span className="add-on">
            <i className="fa fa-clock-o"></i>
          </span> */}
        </div>
      </td>
    </tr>
  );
};

export default AddEmployee;
